<template>
  <div class="container">
    <!-- 行业/新增/编辑详情列表 -->
     <a-modal class="" :title="title[type]" :visible="industryVisible"  @cancel="closeVisible"  width="40%" @ok="submit" >
      <template slot="footer" v-if="type == 1">
      <a-button key="back" @click="closeVisible"> 取消 </a-button>
    </template>
      <div>
          <a-form-model :model="addCategoryList" ref="categoryRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="所属项目"  prop="categoryName">
                            <span>{{ category}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="行业名称"  prop="industryName" :rules="{
								  required: true,
								  message: '请填写行业大类名称',
								  trigger: 'change',
								}">              
                                 <span v-if="type == 1">{{addCategoryList.industryName}}</span>
                                 <a-input v-model="addCategoryList.industryName" v-else></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="创建人"  prop="creator" v-if="type == 1">
                            <span>{{ addCategoryList.creator}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }"
                            label="创建时间"  prop="createTime" v-if="type == 1">
                            <span>{{ addCategoryList.createTime}}</span>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
      </div>
     </a-modal>
  </div>
</template>

<script>
import {industryInfo_post, industryInfo_put} from '@/api/Industry'
export default {
    props: [
        'industryVisible',
        'type',
        'category',
        'addCategoryList'
    ],
  data () {
    return {
      // categoryList: {
      //   categoryName: '',
      //   industryName: ''

      // },
      title: ['新增行业',
              '详情',
              '编辑行业']
    }
  },
  methods: {
    // 弹窗关闭事件
    closeVisible() {
             this.$refs.categoryRef.resetFields()
      this.industryVisible = false
      this.$emit('changeIndustryVisible', this.industryVisible)
      
    },
    // 弹窗提交事件
    submit() {
      if(this.type==0){
         this.$refs.categoryRef.validate( valid=>{
                 if(valid){
                      industryInfo_post({
                        projectId: 4,
                        industryName: this.addCategoryList.industryName
                      }).then(res => {
                        if(res.code == 200) {
                             this.$message.success(res.msg)
                              this.industryVisible = false
                            this.$emit('changeIndustryVisible', this.industryVisible)
                             this.addCategoryList.industryName = ''
                             //刷新列表
                             this.$emit('refreshList')

                         } else {
                          this.$message.error(res.msg)
                         }
                       })

                 }
        })

      }
      if(this.type==2){
             this.$refs.categoryRef.validate( valid=>{
                 if(valid){
                      industryInfo_put({
                        id: this.addCategoryList.id,
                        projectId: 4,
                        industryName: this.addCategoryList.industryName
                      }).then(res => {
                        if(res.code == 200) {
                             this.$message.success(res.msg)
                              this.industryVisible = false
                            this.$emit('changeIndustryVisible', this.industryVisible)
                             this.addCategoryList.industryName = ''
                             
                             //刷新列表
                             this.$emit('refreshList')

                         } else {
                          this.$message.error(res.msg)
                         }
                       })

                 }
        })

      }
       
  

    }
  }

}
</script>

<style>

</style>